import React, { useState } from "react";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button";
import { useSnackbar } from "notistack";
import Box from "@material-ui/core/Box";
import { Typography, makeStyles } from "@material-ui/core";
import {Formik, Form, Field, FormikProps, useFormik} from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { apiEndpoint, gpt3Endpoint } from "../../../Constants/api";
import CollectEmail from "./CollectEmail";
import {colorInputBorder, colorSecondary,colorBlack} from "../../../Constants/theme";
import {ReactComponent as LikeIcon} from "../../../Images/thumb.svg";
import {ReactComponent as DisLikeIcon} from "../../../Images/thumb-down.svg";
import {useHistory} from "react-router";
import {api_setHelpfulAnswer} from "../../../redux/pets/pets.api";
import cn from "classnames";
const ASK_LOCAL_STORE_KEY = "askRalphieLocalEmail";

const useStyles = makeStyles({
    root: {
        "& .MuiFormLabel-root": {
            color: colorInputBorder, // or black
            fontSize: "14px"
        },
    },
    answerFont: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontSize: "18px",
        color: colorInputBorder,
        marginTop: "15px",
    },
    answerTitle: {
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        color: colorBlack,
        marginBottom: "9px",
        marginTop: "27px",
    },
    helpfulTitle: {
        display : "flex",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        color: colorBlack,
        marginBottom: "9px",
        marginTop: "27px",
    },
    submitButton: {
        background: colorSecondary,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "74px",
    },
    likesWrapper: {
        display: "flex",
        marginLeft : "23px"
    },
    dislikeWrapper: {
        marginLeft: "16px",
        "&:hover" : {
            cursor: "pointer",
        },
        "&:first-child":{
            "&:hover" : {
                fill: colorBlack,
                stroke:colorBlack,
            }
        }
    },
    likeWrapper: {
        "&:hover" : {
            cursor: "pointer",
        },
    },
    btnWrapper: {
        display: "flex",
        width : "100%",
        justifyContent: "space-between",
        marginTop: "37px"
    },
    extraBtn: {
        background: colorSecondary,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "74px",
        width: "calc(100% / 2 - 20.5px)"
    },
    likeIcon :{
        fill: colorInputBorder,
        "&:hover" : {
            fill: colorBlack,
            stroke:colorBlack,
        }
    },
    selectedLikeIcon:{
        fill: colorBlack,
        stroke:colorBlack,
    },
    selectedDislikeIcon:{
        fill: colorBlack,
        stroke:colorBlack,
    },
    dislikeIcon :{
        fill: colorInputBorder,
        "&:hover" : {
            fill: colorBlack,
            stroke:colorBlack,
        }
    }
});


export default ({hideExtraInfo}) => {
    const validationSchema = Yup.object().shape({
        question: Yup.string()
            .min(15, "Too short of a question")
            .max(250, "Too long of a question")
            .required("Required"),
    });

    const getLocalEmail = () => window.localStorage.getItem(ASK_LOCAL_STORE_KEY);
    let history = useHistory();
    const [localEmail, setLocalEmail] = useState(getLocalEmail());
    const [askedQuestion, setAskedQuestion] = useState<undefined | string>();
    const [isLike, setIsLike] = useState(null);
    const setLocalStoreEmail = async (email) => {
        window.localStorage.setItem(ASK_LOCAL_STORE_KEY, email);
        setLocalEmail(email);
        const body = {"question": askedQuestion, "email": email };
        const answerRes = await fetch(gpt3Endpoint, {
            method: "POST", body: JSON.stringify(body),
            headers: { "Content-Type": "application/json"}
        });
    };
    const handleVoteHelpfulAnswer =  (body) => {
        api_setHelpfulAnswer(body).then(r => {
            setIsLike(r.isHelpful);
        });
    };
    const { enqueueSnackbar } = useSnackbar();
    const [answer, setAnswer] = useState<string | undefined>();
    const [isHelpfulAnswer, setIsHelpfulAnswer] = useState(false);
    const [waitingForAnswer, setwaitingForAnswer] = useState(false);
    const classes = useStyles();


    const transformAnswer = (answer) => {
        const replacements = [
            "the vet", "a vet", "your vet", "your veterinarian", "a veterinarian"
        ];
        replacements.forEach(k => {
            if (answer.includes(k)){
                answer = answer.replaceAll(k, "a The Video Vets vet");
            }
        });
        return answer;
    };

    return (
        <Formik
            initialValues={{
                question: "",
            }}
            onSubmit={async (values, {setStatus}) => {
                const body = {"question":values.question };
                setAskedQuestion(values.question);
                try{
                    setwaitingForAnswer(true);
                    enqueueSnackbar("Sent question to Ralphie! 🐶", {
                        autoHideDuration: 3000,
                    });
                    hideExtraInfo(false);
                    const answerRes = await fetch(gpt3Endpoint, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    const answerText = await answerRes.json();
                    let answerTextRes = transformAnswer(answerText.response);
                    setIsHelpfulAnswer(!!answerTextRes && !!answerTextRes.length && !answerTextRes.includes("Could not") );
                    setAnswer(answerTextRes);
                    setStatus({success: true});
                    setwaitingForAnswer(false);
                } catch (error) {
                    console.error(error);
                    enqueueSnackbar("Error while processing question. Please try again.", {
                        variant: "error",
                        autoHideDuration: 3000,
                    });
                    setStatus({success: false});
                }
            }}
            validationSchema={validationSchema}
        >
            {
                (props: FormikProps<{question: string}>) => (
                    <Form>
                        <Box
                            display="flex"
                            flexDirection="column"
                            width="100%"
                            marginBottom="16px"
                        >
                            <Field
                                component={TextField}
                                name="question"
                                id="question"
                                aria-labelledby="question"
                                label="Your Question"
                                variant="standard"
                                multiline={true}
                                color="secondary"
                                type="question"
                                margin="normal"
                                onChange={props.handleChange}
                                value={props.values.question}
                                data-testid="questionInput"
                            />
                        </Box>
                        <Box
                            marginBottom={"10pt"}
                        >
                        </Box>
                        <Box
                            marginBottom={"10pt"}
                        >
                            {!isHelpfulAnswer && <Button
                                variant="contained"
                                type="submit"
                                data-testid="submitButton"
                                className={classes.submitButton}
                                fullWidth
                            >
								Send
                            </Button>}
                            {waitingForAnswer ?
                                <Box textAlign="center" marginTop="15px">
                                    <img alt="cat moving in a circle while results are loading" src="/cat-loader.gif" width= "250px"/>
                                    <h3>Fetching...</h3>
                                </Box> :
                                (
                                    answer && !answer.includes("Could not ") && !localEmail   ? <CollectEmail setLocalEmail={setLocalStoreEmail}/>:
                                        <>	{!!answer && !answer.includes("Could not") && <Typography className={classes.answerTitle}>Answer:</Typography>}
                                            {!!answer && !!answer.includes("Could not") ?
                                                <Typography className={classes.answerFont}>
													We’re sorry, we didn’t understand your question.
                                                    <br/>	Try typing your question in one of these formats:<br/>
													“Why is my dog… ?”<br/>
													“What should I do if my cat... ?”<br/>
													“Can my dog… ?”
                                                </Typography> :
                                                <Typography className={classes.answerFont}>{!!answer && answer.substr(3)}</Typography>
                                            }
                                        </>
                                )
                            }
                            {isHelpfulAnswer && <>
                                <Typography className={classes.helpfulTitle}>
									Was this answer helpful?
                                    <div className={classes.likesWrapper}>
                                        <div className={classes.likeWrapper} onClick={()=>{
                                            handleVoteHelpfulAnswer({
                                                "question": props.values.question,
                                                "answer": answer,
                                                "isHelpful" : true,
                                            });
                                        }
                                        }>
                                            <LikeIcon className={cn(classes.likeIcon, !!isLike && classes.selectedLikeIcon)} />
                                        </div>
                                        <div className={classes.dislikeWrapper} onClick={()=>{
                                            handleVoteHelpfulAnswer({
                                                "question": props.values.question,
                                                "answer": answer,
                                                "isHelpful" : false,
                                            });
                                        }
                                        }>
                                            <DisLikeIcon className={cn(classes.dislikeIcon, isLike === false && classes.selectedDislikeIcon)}/>
                                        </div>
                                    </div>
                                </Typography>
                                <div className={classes.btnWrapper}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        data-testid="submitButton"
                                        className={classes.extraBtn}
                                        fullWidth
                                        onClick={()=>history.push("/schedule")}
                                    >
										Speak with a Vet
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        data-testid="submitButton"
                                        className={classes.extraBtn}
                                        fullWidth
                                        onClick={()=>{
                                            hideExtraInfo(true);
                                            setAnswer(undefined);
                                            props.resetForm();
                                            setIsHelpfulAnswer(false);}}
                                    >
										Ask another question
                                    </Button>
                                </div>

                            </>}
                        </Box>
                    </Form>
                )
            }
        </Formik>
    );
};
